//// LEGACY FLAGS ////
// Consider all pre-XFN flags legacy. Should be revised and removed.

/**
 * Fix displaying of created_at in the review mode
 */
export const FF_DEV_1480 = "ff_front_dev_1480_created_on_in_review_180122_short";

/**
 * Model version selector per model backend
 */
export const FF_DEV_1682 = "ff_front_dev_1682_model_version_dropdown_070622_short";

/**
 * Fixes how presigned urls are generated and accessed to remove possibility of CORS errors.
 */
export const FF_LSDV_4711 = "fflag_fix_all_lsdv_4711_cors_errors_accessing_task_data_short";

/**
 * Enables "Enterprise Awareness" features
 */
export const FF_LSDV_E_297 = "fflag_feat_front_lsdv_e_297_increase_oss_to_enterprise_adoption_short";

/**
 * Project list search
 */
export const FF_PROD_281 = "fflag_feat_front_prod_281_project_list_search_19072023_short";
//// END OF LEGACY FLAGS ////

/**
 * Prompter workflow
 */
export const FF_DIA_835 = "fflag_feat_all_dia_835_prompter_workflow_long";

/**
 * Joyride
 */
export const FF_PRODUCT_TOUR = "fflag_feat_dia_1697_product_tour_short";
/**
 * It adds an unsaved changes warning and fix some caching problems on a saving project
 */
export const FF_UNSAVED_CHANGES = "fflag_feat_front_leap_1198_unsaved_changes_180724";

/**
 * Enables JWT tokens
 */
export const FF_AUTH_TOKENS = "fflag__feature_develop__prompts__dia_1829_jwt_token_auth";

export const FF_IMPROVE_GLOBAL_ERROR_MESSAGES = "fflag_feat_front_optic_1746_improve_global_error_messages_short";

/**
 * Enable new home page for LSO and LSE
 */
export const FF_HOMEPAGE = "fflag_all_feat_dia_1777_ls_homepage_short";

/**
 * Sample datasets UI for the import flow
 */
export const FF_SAMPLE_DATASETS = "fflag_feat_dia_1920_project_creation_sample_data_short";

/**
 * JSON preview window for the import flow
 */
export const FF_JSON_PREVIEW = "fflag_feat_dia_1925_view_sample_raw_json_short";

/**
 * Allow to resize spans in Text tag
 */
export const FF_ADJUSTABLE_SPANS = "fflag_feat_front_leap_1973_adjustable_spans_090425_short";

/**
 * Enables the theme toggle in the UI to enable the dark mode
 */
export const FF_THEME_TOGGLE = "fflag_feat_front_optic_1217_theme_toggle_short";

/**
 * Fixes synced audio/video buffering
 */
export const FF_SYNCED_BUFFERING = "fflag_fix_front_fit_31_synced_media_buffering";

/**
 * Enables the summary view for annotations
 */
export const FF_SUMMARY = "fflag_feat_front_leap_2036_annotations_summary";

/**
 * TimeSeries Multi-channel functionality
 */
export const FF_MULTICHANNEL_TS = "fflag_feat_front_bros58_timeseries_multichannel_short";

/**
 * Enables enterprise email notifications
 */
export const FF_ENTERPRISE_EMAIL_NOTIFICATIONS = "fflag_feat_front_fit_183_email_notifications_short";

/**
 * Bitmask is a new image segmentation tool for masking that allows pixel-perfect editing
 *
 * @link https://app.launchdarkly.com/projects/default/flags/fflag_front_feat_bros_87_pixel_wise_16062025_short
 */
export const FF_BITMASK = "fflag_front_feat_bros_87_pixel_wise_16062025_short";

/**
 * New storage providers experience
 * @link https://app.launchdarkly.com/projects/default/flags/fflag_feat_bros_193_new_cloud_storage_providers_short/targeting?env=production&selected-env=production
 */
export const FF_NEW_STORAGES = "fflag_feat_bros_193_new_cloud_storage_providers_short";

/**
 * Datamanager filter members
 */
export const FF_DM_FILTER_MEMBERS = "fflag_feat_fit_449_datamanager_filter_members_short";

/**
 * Modify MST models to allow custom tags
 */
export const FF_CUSTOM_TAGS = "fflag_feat_front_bros_194_custom_tags_short";

/**
 * Multiple labels support for region creation - improved label blocks handling
 */
export const FF_MULTIPLE_LABELS_REGIONS = "fflag_feat_front_bros_327_multiple_labels_regions_short";
